import css from "./interactive_table.module.scss";
import { CellCoord } from "./interactive_table.types";
import { useInteractiveTableActions } from "./interactive_table_store_context";

type FillHandleProps = {
  coord: CellCoord;
};

export const FillHandle = ({ coord }: FillHandleProps) => {
  const actions = useInteractiveTableActions();

  const handleMouseDown = () => {
    actions.startFillDrag(coord);
  };

  return <div role="button" tabIndex={-1} className={css.fillHandle} onMouseDown={handleMouseDown} />;
};
